module.exports = __webpack_public_path__ + "static/media/Rectangle 9 (2).13ea2ce9.png";